import * as React from 'react';
import { GoogleMap, withGoogleMap } from 'react-google-maps';

const mapStyle = require('../styles/mapStyleSilver.json');

const SimpleMap = (props: any) => {
  return (
    <GoogleMap
      defaultOptions={{
        fullscreenControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        streetViewControl: false,
        styles: mapStyle,
        zoomControl: true,
      }}
      center={props.center || { lat: 35.6811673, lng: 139.7670516 }}
      zoom={7}
    >
      {props.children}
    </GoogleMap>
  );
}

const BlankMap = (props: any) => {
  return (
    <div></div>
  );
}

let map;
if ((window as any).google && (window as any).google.maps) {
  map = withGoogleMap(SimpleMap);
} else {
  map = BlankMap;
}

export default map;
